<div class="list-notis d-flex flex-column">
    <div class="title">
        <h2>Thông báo</h2>
    </div>
    <div class="notis-items flex-grow-1">
        <div id="base-notis-scroll" class="notis-scroll __set __apscrollbar_parent">
            <div class="scrollin absolute __apscrollbar_target __regular __scrolled"
                style="inset: 0px -12px 0px 0px;">
                <div class="__apscrollbar_wrap">
                    <div class="base-notis-items">
                        <div class="noti-item url notis" 
                            *ngFor="let notify of notificationItems" [ngClass]="{'unread': notify.notificationStatus == 'Unread'}"
                            (click)="navigateTo(notify)">
                            <one-avatar [imageUrl]="notify.author.avatarUrl" [size]="32"></one-avatar>
                            <div class="text">
                                <div class="-title" [innerHtml]="notify.content"></div>
                                <!-- <div class="content" style="font-size: 12px;">{{notify.content}}</div> -->
                                <div class="info"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="-more std" >
        <button class="btn-load-more" mat-stroked-button (click)="loadMore()">Tải thêm</button>
    </div>
</div>